import {ActionTree} from "vuex";
import {QuantityLimitItem, QuantityLimitState} from "@/store/settings/quantity_limits/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<QuantityLimitState, RootState> = {
    getQuantityLimits: ({commit, dispatch}, data) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                url: '/acapi/quantity_limits', params: {
                    transports: Array.isArray(data?.transports) ? data?.transports?.join() : data?.transports,
                    templates: Array.isArray(data?.templates) ? data?.templates?.join() : data?.templates,
                    message_types: Array.isArray(data?.message_types) ? data?.message_types?.join() : data?.message_types,
                    limit: data?.limit,
                    timeout: data?.timeout,
                }
            })
                .then(resp => {
                    commit('setQuantityLimit', resp.data?.limit_rules);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                }).finally(() => commit('setLoading', false));
        })
    },
    getQuantityLimitItem: ({commit, dispatch}, id) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/quantity_limits/${id}`})
                .then((resp: any) => {
                    let quantityLimitItem = <QuantityLimitItem>resp.data;
                    quantityLimitItem.id = id;
                    commit('setQuantityLimitItem', quantityLimitItem);
                    resolve(quantityLimitItem)
                })
                .catch(err => {
                    reject(err)
                }).finally(() => commit('setLoading', false));
        })
    },
    saveQuantityLimit: ({commit, dispatch}, data: QuantityLimitItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: '/acapi/quantity_limits/' + (data.id ?? ''),
                data: data
            })
                .then((resp: any) => {
                    dispatch('getQuantityLimits');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteQuantityLimit: ({commit, dispatch}, data: QuantityLimitItem) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/quantity_limits/${data.id}`,
                data: data
            })
                .then((resp: any) => {
                    dispatch('getQuantityLimits');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
}
